import React from 'react';
import { Button } from '@finpay-development/shared-components';
import { 
  Dialog, 
  DialogActions, 
  DialogContent, 
  DialogTitle, 
  Grid, 
  Typography 
} from '@mui/material';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { PreEnrollRequirement } from '../utils/pre-enroll-validation';

interface PreEnrollErrorModalProps {
  isOpen: boolean;
  handleModalClose: () => void;
  requirementList: PreEnrollRequirement[];
  isLoading?: boolean;
}

export function PreEnrollErrorModal(props: PreEnrollErrorModalProps) {
  const { isOpen, handleModalClose, requirementList, isLoading = false } = props;
  
  const failedRequirements = requirementList.filter((item) => !item.status);

  return (
    <Dialog
      scroll="paper"
      className="modal user-modal requirements-modal"
      open={isOpen}
      aria-labelledby="pre-enroll-error-dialog-title"
      maxWidth="md"
      test-id="pre-enroll-error-modal"
    >
      <DialogTitle className="spa-modal-title">
        Missing Enroll Requirements
      </DialogTitle>
      <DialogContent dividers>
        <Grid container direction="row" style={{ padding: "1.5rem 0 2rem 0" }}>
          <Typography 
            className="pt-2" 
            style={{ 
              paddingTop: "0", 
              fontSize: "16px", 
              paddingBottom: "20px", 
              fontFamily: "Inter", 
              lineHeight: "25px", 
              fontWeight: "400", 
              color: "#808080" 
            }}
          >
            The following items need to be addressed in order to enroll in this Payment Program:
          </Typography>
          
          {isLoading && (
            <Grid 
              container 
              direction="row" 
              style={{ 
                fontFamily: 'Inter, sans-serif', 
                fontWeight: "400", 
                fontSize: "16px", 
                padding: "8px 0", 
                alignItems: "center" 
              }}
            >
              <FiberManualRecordIcon 
                style={{ 
                  color: "#df1e44", 
                  border: "1px solid red", 
                  borderRadius: "50%", 
                  paddingTop: "0px", 
                  marginRight: "8px", 
                  fontSize: "12px" 
                }} 
                className="pt-3" 
                fontSize="small"
              />
              <span>IOC and Patient data have not fully loaded.</span>
            </Grid>
          )}
          
          {!isLoading && failedRequirements.map((requirement, index) => (
            <Grid 
              key={index}
              container 
              direction="column" 
              style={{ 
                fontFamily: 'Inter, sans-serif', 
                fontWeight: "400", 
                fontSize: "16px", 
                padding: "8px 0", 
              }}
              test-id={`pre-enroll-requirement-${index}`}
            >
              <Grid container direction="row" style={{ alignItems: "center" }}>
                <FiberManualRecordIcon 
                  style={{ 
                    color: "#df1e44", 
                    border: "1px solid red", 
                    borderRadius: "50%", 
                    paddingTop: "0px", 
                    marginRight: "8px", 
                    fontSize: "12px" 
                  }} 
                  className="pt-3" 
                  fontSize="small"
                />
                <span test-id={`pre-enroll-requirement-text-${index}`}>{requirement.requirementName}</span>
              </Grid>
              {requirement.missingFields && requirement.missingFields.length > 0 && (
                <Grid 
                  container 
                  direction="column" 
                  style={{ 
                    marginLeft: "28px", 
                    marginTop: "4px",
                    fontSize: "14px",
                    color: "#666"
                  }}
                >
                  <span style={{ fontWeight: "500", marginBottom: "4px" }}>Missing:</span>
                  <ul style={{ margin: "0", paddingLeft: "20px" }}>
                    {requirement.missingFields.map((field, fieldIndex) => (
                      <li key={fieldIndex} style={{ marginBottom: "2px" }}>{field}</li>
                    ))}
                  </ul>
                </Grid>
              )}
            </Grid>
          ))}
        </Grid>
      </DialogContent>
      <DialogActions style={{ borderTop: "", marginTop: "0", padding: "2rem" }}>
        <Button onClick={handleModalClose} test-id="pre-enroll-error-modal-close-btn">
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default PreEnrollErrorModal;
